interface UkiyoWaveDividerProps {
  isUkiyo: boolean;
}

export function UkiyoWaveDivider({ isUkiyo }: UkiyoWaveDividerProps) {
  if (!isUkiyo) return null;

  return (
    <div style={{ margin: '12px 0', overflow: 'hidden', height: 14 }}>
      <svg viewBox="0 0 400 14" preserveAspectRatio="none" width="100%" height="14">
        <path d="M0 7 Q20 2 40 7 Q60 12 80 7 Q100 2 120 7 Q140 12 160 7 Q180 2 200 7 Q220 12 240 7 Q260 2 280 7 Q300 12 320 7 Q340 2 360 7 Q380 12 400 7"
          stroke="#1B5C8A" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M0 10 Q20 5 40 10 Q60 15 80 10 Q100 5 120 10 Q140 15 160 10 Q180 5 200 10 Q220 15 240 10 Q260 5 280 10 Q300 15 320 10 Q340 5 360 10 Q380 15 400 10"
          stroke="#B8860B" strokeWidth="0.7" fill="none" opacity="0.4" />
      </svg>
    </div>
  );
}

interface GoldCornersProps {
  size?: number;
}

export function GoldCorners({ size = 10 }: GoldCornersProps) {
  return (
    <>
      <div style={{ position: 'absolute', top: 5, left: 5, width: size, height: size, borderTop: '1.5px solid #B8860B', borderLeft: '1.5px solid #B8860B', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: 5, right: 5, width: size, height: size, borderBottom: '1.5px solid #B8860B', borderRight: '1.5px solid #B8860B', pointerEvents: 'none' }} />
    </>
  );
}
